import { UserService } from "./../_services/user.service";
import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "dateSti",
})
export class DateStiPipe implements PipeTransform {
  constructor(private userServ: UserService) {}

  lang: string = this.userServ.getDefaultLanguage();
  datePipe: DatePipe = new DatePipe(this.lang);

  /**
   *  Przetważa datę na format 'dd.MM.YYYY HH:mm' lub 'dd.MM.YYYY' w wersji angielskiej zamiast . jest /
   * @param value wartość do przetransformowania
   * @param showTime określa rodzaj zformatowanej daty full - Data z godziną, onlyDate - Sama data,
   *  onlyHour - Sama godzina, domyślnie ustawiona full
   * @param lang wybór formatu daty według języka, przyjmuje wartość en lub pl
   * @returns Zformatowana data, godzina lub data z godziną
   */
  transform(
    value: number | string | Date,
    showTime: "full" | "onlyDate" | "onlyHour" = "full",
    lang: string = this.lang
  ): unknown {
    switch (showTime) {
      case "full": {
        if (lang === "en") {
          return this.datePipe.transform(value, "MM/dd/yyyy hh.mm a");
        } else {
          return this.datePipe.transform(value, "dd.MM.yyyy HH:mm");
        }
      }
      case "onlyDate": {
        if (lang === "en") {
          return this.datePipe.transform(value, "MM/dd/yyyy");
        } else {
          return this.datePipe.transform(value, "dd.MM.yyyy");
        }
      }
      case "onlyHour": {
        if (lang === "en") {
          return this.datePipe.transform(value, "hh.mm a");
        } else {
          return this.datePipe.transform(value, "HH:mm");
        }
      }
    }
  }
}
